module.exports = __webpack_public_path__ + "img/new-year-bee.18687699.svg";